import React, { Suspense, lazy, useEffect, useState } from 'react';
import { Router } from 'react-router';
import { Route, Switch, withRouter } from 'react-router-dom';

import publicRouter from './publicRouter';
import { history } from '../utils/history';

const NotFound = lazy(() => import('../modules').then(module => ({ default: module.NotFound })));

const SwitchRouter = () => {
  const [routes, setRoutes] = useState([]);

  useEffect(() => {
    const routers = [];

    if (checkRouter(publicRouter)) {
      routers.push(checkRouter(publicRouter));
    }

    setRoutes(routers);
  }, [setRoutes]);

  const checkRouter = routers => {
    if (routers && Object.keys(routers).length && routers.subRoutes) {
      return routers;
    }
  };

  return (
    <Suspense fallback={<div>Loading ...</div>}>
      <Router history={history}>
        <Switch>
          {routes.map((route, i) => (
            <Route key={i} exact={route.subRoutes.some(r => r.exact)} path={route.subRoutes.map(r => r.path)}>
              <route.layout>
                {route.subRoutes.map((subRoute, i) => (
                  <Route key={i} {...subRoute} />
                ))}
              </route.layout>
            </Route>
          ))}
          <Route exact component={NotFound} />
        </Switch>
      </Router>
    </Suspense>
  );
};

export default withRouter(SwitchRouter);
